import { URLS } from './constants';

export const normalizeAuth0Props = (auth0Props) => {
  const { user, ...rest } = auth0Props;

  // If we are not authenticated, the user object is null/undefined
  if (!user) {
    return { user, ...rest };
  }

  const { email, ...restUser } = user;

  // Preserve null/undefined, only lowercase actual string values
  if (!email) {
    return { user, ...rest };
  }

  return {
    user: {
      ...restUser,
      email: email.toLowerCase()
    },
    ...rest
  };
};

export function getCurrentURL(history) {
  const { pathname, search } = history.location;
  return `${pathname}${search}`;
}

export function handleUnauthorised(history) {
  const currentURL = getCurrentURL(history);

  // We may already be in the UNAUTHORISED page, this is because
  // we redirect using an interceptor, and many calls can have the same
  // status at the same time.
  // This will avoid a race condition.
  if (currentURL.startsWith(URLS.UNAUTHORISED)) {
    return;
  }

  history.replace(URLS.UNAUTHORISED, {
    originalUrl: currentURL
  });
}

export function handleUnauthenticated(loginWithRedirect, history) {
  const currentURL = getCurrentURL(history);

  loginWithRedirect({
    appState: {
      returnTo: currentURL
    }
  });
}
